import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';

import { DatePipe } from '@angular/common';
import {
  AuthenticationService,
  ApplicationTaxRequestApiService,
  ApprovalTaskItemApiService,
} from '../../data-services/index';

import {
  IApplication,
  IApprovalTask,
  IApprovalTaskItem,
  IUser,
  IRecipient,
  IApplicationTaxRequest,
  SignerInput,
  IDocumentProcessorResponse,
  IHelp,
} from '@ebb-v2/ebb-integration';
import { forkJoin, Observable } from 'rxjs';
import { map, defaultIfEmpty } from 'rxjs/operators';

import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';
import { DialogConfirmIvDeleteComponent } from '../dialog/dialog-confirm-iv-delete.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';




@Component({
  selector: 'ebb-portal-tax-list',
  templateUrl: './tax-list.component.html'
})
export class TaxListComponent implements OnInit, OnChanges {
  @Input('context') context: string;
  @Input('title') title: string;
  @Input('application') application: IApplication;
  @Input('task') task: IApprovalTask;
  @Input('email') email: string;
  @Output() emitDocuUrlOpenEvent = new EventEmitter<boolean>();
  @Output() resubmitTaxRequestDataEvent = new EventEmitter<IApprovalTaskItem>();
  @Output() anyRejected4506cItemsDisplayedEvent = new EventEmitter<boolean>();
  @Output() submitTaxRequestDataEvent = new EventEmitter<IApprovalTaskItem>();
  @Output() ondeleteIVR = new EventEmitter<IApprovalTask>();

  public currentUser: IUser;

  public taskItems: IApprovalTaskItem[] = [];

  public innerWidth: number;
  public autoSaveIndicator = false;
  public disablebuttton = false;
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly apiTaxRequest: ApplicationTaxRequestApiService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly infoSheet: MatBottomSheet,
    private datePipe: DatePipe,
    private readonly dialogConfirmDelete: MatDialog,
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.taskItems = this.task.approvalTaskItems.filter(
      x => x.payloadTypeCode === 700000002 && x.stateCode === 0
    );
    this.innerWidth = window.innerWidth;
  }

  ngOnChanges() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.taskItems = this.task.approvalTaskItems.filter(
      x => x.payloadTypeCode === 700000002 && x.stateCode === 0
    );
  }

  public lookupIndex(item: IApprovalTaskItem): number {
    return this.task.approvalTaskItems.findIndex(i => i.id === item.id);
  }

  public getName(recipients: IRecipient[]): string {
    let result: string;
    
    if (recipients === null) {
      result = '';
    } else {
      const signer1 = recipients.filter(x => x.primary);
      const signer2 = recipients.filter(x => !x.primary);
      
      if (signer1.length > 0) {
        result = 
          signer1[0].nameMiddle !== null && signer1[0].nameMiddle.toString().length > 0 
          ? 
          signer1[0].nameFirst.toString() + ' ' + signer1[0].nameMiddle.toString()+ ' ' + signer1[0].nameLast.toString()
          :
          signer1[0].nameFirst !== null && signer1[0].nameFirst.toString().length > 0
          ? 
          signer1[0].nameFirst.toString() + ' ' + signer1[0].nameLast.toString()
          :
          signer1[0].name.toString()
          ;
      }
      
      if (signer2.length > 0) {
        result = 
          result + 
          ' & ' + 
          (
            signer2[0].nameMiddle !== null && signer2[0].nameMiddle.toString().length > 0 
            ? 
            signer2[0].nameFirst.toString() + ' ' + signer2[0].nameMiddle.toString()+ ' ' + signer2[0].nameLast.toString()
            :
            signer2[0].nameFirst !== null && signer2[0].nameFirst.toString().length > 0
            ? 
            signer2[0].nameFirst.toString() + ' ' + signer2[0].nameLast.toString()
            :
            signer2[0].name.toString()
            ) +
          ' (Joint return)';
      }
    }

    return result;
  }

  public async goToLink(recipient: IRecipient, taskitem: IApprovalTaskItem) {
    this.disablebuttton = true;
    const request: IApplicationTaxRequest = {} as IApplicationTaxRequest;
    request.applicationId = this.application.id;
    request.approvalTaskId = this.task.id;
    request.email = this.email;
    request.dwellingId = this.application._Ebb_DwellingId;

    if (recipient.documentId) {
      request.documentId = recipient.documentId;
    } else {
      request.documentId = null;
    }

    if (this.application.envelopeId) {
      request.envelopeId = this.application.envelopeId;
    } else {
      request.envelopeId = null;
    }

    if (taskitem.recipients !== null && taskitem.recipients.length > 0) {
      const primary = taskitem.recipients.filter(x => x.primary);
      const secondary = taskitem.recipients.filter(x => !x.primary);

      const signer1: SignerInput = {} as SignerInput;
      signer1.signerName = primary[0].name;
      signer1.signerNameFirst = primary[0].nameFirst;
      signer1.signerNameMiddle = primary[0].nameMiddle;
      signer1.signerNameLast = primary[0].nameLast;
      signer1.clientId = primary[0].clientId;
      signer1.recipientId = primary[0].recipientId;
      signer1.viewUrl = '';
      signer1.recipientIdD365 = primary[0].id;
      signer1.taskItemId = taskitem.id;
      request.signer1 = signer1;

      if (secondary.length > 0) {
        const signer2: SignerInput = {} as SignerInput;
        signer2.signerName = secondary[0].name;
        signer2.signerNameFirst = secondary[0].nameFirst;
        signer2.signerNameMiddle = secondary[0].nameMiddle;
        signer2.signerNameLast = secondary[0].nameLast;
        signer2.clientId = secondary[0].clientId;
        signer2.recipientId = secondary[0].recipientId;
        signer2.viewUrl = '';
        signer2.recipientIdD365 = secondary[0].id;
        signer2.taskItemId = taskitem.id;
        request.signer2 = signer2;
      } else {
        const signer2: SignerInput = {} as SignerInput;
        signer2.signerName = '';
        signer2.signerNameFirst = '';
        signer2.signerNameMiddle = '';
        signer2.signerNameLast = '';
        signer2.clientId = '';
        signer2.recipientId = '';
        signer2.viewUrl = '';
        signer2.recipientIdD365 = '';
        signer2.taskItemId = '';
        request.signer2 = signer2;
      }
    }
    const events = [];

    var returnUrl = window.location.host;
    events.push(
      this.get4506cViewUrls(
        request.applicationId,
        request.approvalTaskId,
        this.application._Ebb_DwellingId,
        request.signer1,
        request.signer2,
        request.email,
        request.envelopeId,
        request.documentId,returnUrl
      )
    );
    const windowDocuSignReference = window.open('', '_self');
    forkJoin(events)
      .pipe(defaultIfEmpty(null))
      .subscribe(
        data => {
          if (data !== null) {
            let response: IDocumentProcessorResponse = {} as IDocumentProcessorResponse;
            response = data[0].documentProcessorResponse;
            const signerDto = response.signerDtos.filter(
              x => x.recipientId === recipient.recipientId
            );
            if (signerDto.length > 0) {
              windowDocuSignReference.location.href = signerDto[0].viewUrl;
              this.emitDocuUrlOpenEvent.emit(true);
            } else {
              windowDocuSignReference.document.write(
                'An unexpected error loading document, please contact customer service to resolve the issue. 1A'
              );
            }
          }
        },
        error => {
          console.warn(`ERROR: goToLink() - ${error}`);
          windowDocuSignReference.document.write(
            'An unexpected error loading document, please contact customer service to resolve the issue. 1B'
          );
        }
      );
  }

  public getStatus(item: IApprovalTaskItem): string {
    const recipients = item.recipients;
    let status = 'Waiting for submission';

    if (recipients === null) {
      return status;
    }

    const signer1 = recipients.filter(x => x.primary)[0];

    if (item.statusCode === 700000000) {
      status = 'Waiting for submission';
    }

    if (item.statusCode === 700000003 && !this.application.envelopeOkToVerify) {
      status =
        'Completed Date: ' +
        this.getFormattedDate(signer1.signingDate.toString());
    }

    //updated
    if (item.statusCode === 700000003 && this.application.envelopeOkToVerify) {
      let submitteddate = '';
      if(this.application.sGSubmittedDate){
      submitteddate = this.getFormattedDate(
        this.application.sGSubmittedDate.toString()
      );}
      //submitted
      if (signer1.recipientStatus === 700000001) {
        if (signer1.verificationSubmitted) {
          submitteddate = this.getFormattedDate(
            signer1.verificationSubmitted.toString()
          );
        }
      }
      status = 'Submitted Date: ' + submitteddate;
    }

    //rejected
    if (item.statusCode === 700000002) {
      status =
        status +
        '  |  Attempt: ' +
        (item.attempt === undefined ? '1' : item.attempt);
    }

    else if (
      (item.statusCode === 700000001 || item.statusCode === 700000002)
    ) {
      let date = '';
      if(this.application.sGSubmittedDate){
      date = this.getFormattedDate(
        this.application.sGSubmittedDate.toString()
      );
      }
      //Success
      if (signer1.recipientStatus === 700000002) {
        if (signer1.verificationCompleted) {
          date = this.getFormattedDate(
            signer1.verificationCompleted.toString()
          );
        }
        if(signer1.verificationStatus ==='-1103'){
          if( signer1.verificationSubmitted){
          date = this.getFormattedDate(
            signer1.verificationSubmitted.toString()
          );}
        }
      }
      //Error
      if (signer1.recipientStatus === 700000003) {
        if (signer1.verificationErrorDate) {
          date = this.getFormattedDate(
            signer1.verificationErrorDate.toString()
          );
        }
      }
      status = 'Completed Date:  ' + date;
    }

    return status;
  }

  public onClickShowReasonWhy(topic: string): void {
    const item: IHelp = {} as IHelp;
    item.question = 'Reason Why';
    item.answer = topic.replace(/(\r\n|\n|\r)/gm, '<br/>');
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

  public getDocustatus(item: IApprovalTaskItem): string {
    const recipients = item.recipients;
    let status = '';

    if (recipients === null) {
      return status;
    }
    const signer1 = recipients.filter(x => x.primary)[0];
    if (item.statusCode !== 700000000) {
      if (
        item.statusCode === 700000003 &&
        !this.application.envelopeOkToVerify
      ) {
        status = 'READY TO SUBMIT';
      }
      if (
        item.statusCode === 700000003 &&
        this.application.envelopeOkToVerify
      ) {
        status = 'SUBMITTED';
      }
      if (
        signer1.recipientStatus === 700000005 || signer1.recipientStatus === 700000001
      ) {
        status = 'SUBMITTED';
      }
      if (
        signer1.recipientStatus === 700000002
      ) {
        status = 'IRS COMPLETED';
      }
      if (
        signer1.recipientStatus === 700000002 && signer1.verificationStatus ==='-1103'
      ) {
        status = 'Review in Process';
      }
    }
    return status;
  }

  public CanShowWhy(item: IApprovalTaskItem): boolean {
    const recipients = item.recipients;

    if (
      (recipients === null || recipients === undefined) && 
      item.reasonWhy !== null
    ) {
      return true;
    }

    if (recipients === null || recipients === undefined) {
      return false;
    }

    let status = false;
    const signer1 = recipients.filter(x => x.primary)[0];

    if (item.statusCode !== 700000000) {

      if (
        item.statusCode === 700000003 && //Updated
        !this.application.envelopeOkToVerify && 
        item.reasonWhy !== null &&
        (signer1.verificationStatus === "Not Submitted" || signer1.verificationStatus === "Not Signed")
      ) {
        status = true;
      }

      if (
        item.statusCode === 700000003 &&
        this.application.envelopeOkToVerify
      ) {
        status = false;
      }

      if (
        signer1.recipientStatus === 700000002
      ) {
        status = false;
      }

      if (
        signer1.recipientStatus === 700000002 && 
        signer1.verificationStatus ==='-1103' && 
        item.statusCode ===700000002 && 
        item.reasonWhy !==null
      ) {
        status = true;
      }

      if (
        signer1.recipientStatus === 700000005
      ) {
        status = false;
      }

      if (
        item.statusCode === 700000002 && 
        item.reasonWhy !==null
      ) {
        status = true;
      }
    }

    if (
      item.statusCode === 700000000 && //Pending
      !this.application.envelopeOkToVerify && 
      item.reasonWhy !== null &&
      (signer1.verificationStatus === "Not Submitted" || signer1.verificationStatus === "Not Signed")
    ) {
      status = true;
    }
    
    if (
      item.statusCode === 700000002 &&
      !this.application.envelopeOkToVerify && 
      item.reasonWhy !==null
    ) {
      status = true;
    }

    return status;
  }

  public IsOkToDelete(item: IApprovalTaskItem): boolean {
    const recipients = item.recipients;
    let candelete = false;

    if (recipients === null) {
      return false;
    }
    const signer1 = recipients.filter(x => x.primary)[0];
    if (item.statusCode === 700000000 && !this.application.envelopeOkToVerify && item.reasonWhy === null) {
      candelete =true;
    }

    if (item.statusCode !== 700000000) {
      if (
        item.statusCode === 700000003 &&
        !this.application.envelopeOkToVerify && item.reasonWhy === null
      ) {
        candelete =true;
      }
      
    }
    if (
      signer1.recipientStatus === 700000005 || signer1.recipientStatus === 700000001
    ) {
      candelete = false;
    }
    
    return candelete;
  }

  public onClickResubmitTaxRequestData(item: IApprovalTaskItem): void {
    this.resubmitTaxRequestDataEvent.emit(item);
  }
  public onClickSubmitTaxRequestData(item: IApprovalTaskItem): void {
    this.submitTaxRequestDataEvent.emit(item);
  }

  public onDeleteTaxRequestData(task:IApprovalTask): void {
    this.ondeleteIVR.emit(task);
  }

  private get4506cViewUrls(
    applicationId: string,
    approvalTaskId: string,
    dwellingId: string,
    signer1: SignerInput,
    signer2: SignerInput,
    email: string,
    envelopeId: string,
    documentId: string,
    returnUrl: string
  ): Observable<any> {
    return this.apiTaxRequest
      .get4506cViewUrls(
        applicationId,
        approvalTaskId,
        dwellingId,
        signer1,
        signer2,
        email,
        envelopeId,
        documentId,
        returnUrl
      )
      .pipe(
        map(result => {
          if (!result) {
            console.log('error get4506cViewUrls');
          } else {
            console.log('get4506cViewUrls');
          }
          return result;
        })
      );
  }
  public onDeleteEvent(
    itemId: string
  ): void {
    const currentTaskItem: IApprovalTaskItem = this.taskItems.filter(
      i => i.id === itemId
    )[0];

    const dialogRef = this.dialogConfirmDelete.open(
      DialogConfirmIvDeleteComponent,
      {
        width: '400px',
        data: ''
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.autoSaveIndicator = true;
        if (currentTaskItem.id && currentTaskItem.id.length > 0) {
          this.apiApprovalTaskItem.deactivateItem(itemId,this.application.id).subscribe(
            data => {
              const index = this.task.approvalTaskItems.findIndex(
                i => i.id === data.id
              );
              this.task.approvalTaskItems.splice(index, 1);
              this.autoSaveIndicator = false   
              this.onDeleteTaxRequestData( this.task);
                   
          
            },
            error =>
              console.warn(
                `ERROR: cannot delete approval task item file ${JSON.stringify(
                  error
                )}`
              )
          );
        } else {
          console.warn(`ERROR: Unable to delete file without ID`);
        }
      }
    });
  }
  public getFormattedDate(input: string): string {
    const permitDateUTC = new Date(input);

    permitDateUTC.setHours(permitDateUTC.getHours() - 8);

    const permitDatePST = new Date(permitDateUTC);

    const year = permitDatePST.getFullYear();

    let month = (1 + permitDatePST.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = permitDatePST.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return `${month}/${day}/${year}`;
  }

}
